import { render, staticRenderFns } from "./TestGroup.vue?vue&type=template&id=eb60f600&scoped=true"
import script from "./TestGroup.vue?vue&type=script&lang=js"
export * from "./TestGroup.vue?vue&type=script&lang=js"
import style0 from "./TestGroup.vue?vue&type=style&index=0&id=eb60f600&prod&scoped=true&lang=css"
import style1 from "./TestGroup.vue?vue&type=style&index=1&id=eb60f600&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb60f600",
  null
  
)

export default component.exports